import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-post-login-page',
  templateUrl: './post-login-page.component.html',
  styleUrls: ['./post-login-page.component.css']
})
export class PostLoginPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
